import styled from 'styled-components'
import { maxWidth } from '@/assets/styles/mixins.css'
import vars from '@/assets/styles/vars'
import Review from './StyledReview'
import { loadableStyles } from '@/assets/styles/global.css'

const LoadableSlider = styled.div`
  ${maxWidth(vars.breakpoints.tablet - 1)`
    .swiper-container {
      display: flex;
    }

    .swiper-wrapper {
      height: auto;
    }

    ${Review} {
      justify-content: space-between;
      height: 100%;
    } 
  `}

  .swiper-slide {
    ${loadableStyles}
  }
`

LoadableSlider.Button = styled.div`
  margin-top: 32px;
  text-align: center;
`

export default LoadableSlider
